/* v28 (owner, 2026-10-28: "improve that section to the maximum"): the phone demo's motion (dex-v31.css).
   - is-vis on the section while it is on screen (everything else pauses off screen);
   - the label: its number counts up the first time it comes into view, "Dex" in the brand gradient (screen readers
     keep the plain words through aria-label);
   - the phone tilts and the glow and the problem rows drift with the pointer (wide screens with a mouse);
   - the phone's story plays again every 10 s while on screen;
   - one by one, a problem chip in plain view lights up as fixed.
   With less motion only the label's colours apply. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-dex-showcase]').forEach(function (sec) {
    var title = sec.querySelector('.dex-pb__title');
    var num = null;
    var target = 0;
    if (title) {
      title.setAttribute('aria-label', title.textContent.replace(/\s+/g, ' ').trim());
      var text = title.querySelector('.dex-pb__text') || title;
      Array.prototype.slice.call(text.childNodes).forEach(function (node) {
        if (node.nodeType !== 3 || !/\d|Dex/.test(node.textContent)) return;
        var frag = document.createDocumentFragment();
        node.textContent.split(/(\d+|Dex)/).forEach(function (part) {
          if (!part) return;
          if (/^\d+$/.test(part) && !num) {
            num = document.createElement('span');
            num.className = 'dex-pb__num';
            num.textContent = part;
            target = parseInt(part, 10);
            frag.appendChild(num);
          } else if (part === 'Dex') {
            var b = document.createElement('span');
            b.className = 'dex-pb__brand';
            b.textContent = part;
            frag.appendChild(b);
          } else frag.appendChild(document.createTextNode(part));
        });
        node.parentNode.replaceChild(frag, node);
      });
    }
    if (reduce || !('IntersectionObserver' in window)) { sec.classList.add('is-vis'); return; }

    // the number counts up the first time the label is well in view
    if (num && target > 1) {
      num.textContent = '0';
      var counted = false;
      var cio = new IntersectionObserver(function (es) {
        if (counted || !es[0].isIntersecting) return;
        counted = true; cio.disconnect();
        var t0 = performance.now();
        var step = function (t) {
          var k = Math.min(1, (t - t0) / 1400);
          num.textContent = String(Math.round(target * (1 - Math.pow(1 - k, 3))));
          if (k < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }, { threshold: 0.9 });
      cio.observe(title);
    }

    var phone = sec.querySelector('[data-dex-phone]');
    var chips = Array.prototype.slice.call(sec.querySelectorAll('.dex-pb__chip'));
    var loop = null; var fixer = null;
    // the story again: it clears, then plays from the start
    var replay = function () {
      if (!phone || !phone.classList.contains('is-in')) return;
      phone.classList.add('is-out');
      setTimeout(function () {
        phone.classList.remove('is-in', 'is-out');
        void phone.offsetWidth;
        phone.classList.add('is-in');
      }, 480);
    };
    // a chip in plain view (not fading at the edges or behind the phone) lights up as fixed
    var fixOne = function () {
      var w = window.innerWidth;
      var wide = w >= 990;
      var ph = phone ? phone.getBoundingClientRect() : null;
      var lit = 0;
      var pool = chips.filter(function (c) {
        if (c.classList.contains('is-fix')) { lit++; return false; }
        var r = c.getBoundingClientRect();
        if (!r.width || r.left < w * 0.12 || r.right > w * 0.88 || r.bottom < 0 || r.top > window.innerHeight) return false;
        if (wide && ph && r.top < ph.bottom && r.left < ph.right + 90 && r.right > ph.left - 90) return false;
        return true;
      });
      if (lit >= 2 || !pool.length) return;
      var c = pool[Math.floor(Math.random() * pool.length)];
      c.classList.add('is-fix');
      setTimeout(function () { c.classList.remove('is-fix'); }, 2600);
    };
    var start = function () {
      if (!loop) loop = setInterval(replay, 10000);
      if (!fixer && chips.length) fixer = setInterval(fixOne, 1100);
    };
    var stop = function () { clearInterval(loop); clearInterval(fixer); loop = null; fixer = null; };
    new IntersectionObserver(function (es) {
      var on = es[0].isIntersecting;
      sec.classList.toggle('is-vis', on);
      if (on) start(); else stop();
    }, { rootMargin: '60px 0px' }).observe(sec);

    // the pointer: the phone tilts toward it, the glow and the rows drift (wide screens with a mouse)
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var raf = 0; var mx = 0; var my = 0;
    var apply = function () {
      raf = 0;
      sec.style.setProperty('--dex-mx', mx.toFixed(3));
      sec.style.setProperty('--dex-my', my.toFixed(3));
    };
    sec.addEventListener('pointermove', function (e) {
      if (!fine.matches || window.innerWidth < 990 || e.pointerType !== 'mouse') return;
      var r = sec.getBoundingClientRect();
      mx = Math.max(-1, Math.min(1, (e.clientX - (r.left + r.width / 2)) / (r.width / 2)));
      my = Math.max(-1, Math.min(1, (e.clientY - (r.top + r.height / 2)) / (r.height / 2)));
      if (!raf) raf = requestAnimationFrame(apply);
    });
    sec.addEventListener('pointerleave', function () { mx = 0; my = 0; if (!raf) raf = requestAnimationFrame(apply); });
  });
})();
